// ResourceEfficiency.js
import React from 'react';
import AlertTypePage from './AlertTypePage';

const ResourceEfficiency = () => {
    return <AlertTypePage alertType="Resource Efficiency" title="Resource Efficiency Alerts" />;
};

export default ResourceEfficiency;